import { Entity, Column, PrimaryGeneratedColumn, ManyToOne } from "typeorm";
import { AddressEntity } from "./address.entity";
import { CustomerEntity } from "./customer.entity";
import { ServiceTypeEntity } from "./servicetype.entity";

@Entity()
export class ServiceEntity {

    @PrimaryGeneratedColumn()
    serviceId: number;

    @Column({unique:true})
    ontSerialNum: string;

    @ManyToOne(() => CustomerEntity, customerId => customerId.customerId)
    customerId: CustomerEntity;

    @ManyToOne(() => AddressEntity, location => location.addressId)
    location: AddressEntity

    @ManyToOne(() => ServiceTypeEntity, serviceType => serviceType.serviceTypeId)
    serviceType: ServiceTypeEntity

}